module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Leutwil-7f8088a8c7e59866f03965f869cc4ccd.svg";